<div class="business-entity-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title
			>{{ data.mode === 'PENDING' ? ('ASSORTED.PENDING' | translate) : ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span
		>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if(data.mode === 'PENDING') {
		<div class="w-100 d-flex justify-content-center">
			<mat-spinner></mat-spinner>
		</div>
		} @if (data.mode === 'NEW' || data.mode === 'EDIT') {

		<form [formGroup]="formGroup" class="pe-2 pt-2" (keydown.enter)="action()">
			@for(langCode of avaliableLanguagesCodes; track $index) {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME' | translate }}</mat-label>
					<input matInput type="text" [formControlName]="'name' + (langCode | titlecase)" />
					<button class="me-1" mat-icon-button matSuffix type="button" disabled>
						<img [src]="externalAssets + '/flags/' + langCode + '.svg'" />
					</button>
				</mat-form-field>
			</div>
			}

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.EMBS' | translate }}</mat-label>
					<input matInput type="text" formControlName="embs" minlength="6" maxlength="8" (keyup)="checkEmbsValue($event)" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.ADDRESS' | translate }}</mat-label>
					<input matInput type="text" formControlName="address" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.CITY' | translate }}</mat-label>
					<input matInput type="text" formControlName="city" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.COUNTRY' | translate }}</mat-label>
					<input matInput type="text" formControlName="country" />
				</mat-form-field>
			</div>
		</form>

		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name', true) }}? </span>
		} @else if (data.mode === 'DELETE_REASSIGN') {
		<div class="pb-2">
			<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name', true) }}? </span>
			<br />
			<span> {{ utils.getParameterByLanguageScript(data.item, 'name', true) }} {{ data.type + '.DELETE_RELATED_WITH_DATA' | translate }} ( {{ itemRelatedData }} ) </span>
		</div>

		<form [formGroup]="formGroup" class="row">
			<mat-form-field>
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<input type="text" matInput formControlName="reassignTo" [matAutocomplete]="mediumAutocomplete" [readonly]="formGroup.controls['reassign'].value" />
				<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
					@for (filteredItem of filteredBusinessEntities; track $index) {
					<mat-option [value]="filteredItem">{{utils.getParameterByLanguageScript(filteredItem, 'name', true)}}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>

			<div class="row pb-0">
				<mat-checkbox class="mt-2" color="primary" formControlName="reassign">
					<span>{{ data.type + '.REASSIGN_CONFIRMATION' | translate }}</span>
				</mat-checkbox>
			</div>
		</form>
		}
	</mat-dialog-content>
	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DELETE' || data.mode === 'DELETE_REASSIGN') {
		<div class="d-flex justify-content-end pt-0">
			<button
				mat-flat-button
				color="warn"
				(click)="action()"
				[disabled]="data.mode !== 'DELETE' && !(formGroup.controls['reassignTo'].value || formGroup.controls['reassign'].value)">
				{{ 'ASSORTED.YES' | translate }}
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog()">{{ 'ASSORTED.NO' | translate }}</button>
		</div>
		} @else {
		<div class="d-flex pt-0">
			<button mat-flat-button color="primary" (click)="action()" [disabled]="!action('VALIDATION') || apiLoading.management">
				<div class="d-flex">
					@if(apiLoading.management) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SAVE' | translate }}</span>
				</div>
			</button>
		</div>
		}
	</mat-dialog-actions>
</div>
